<template>
<div class="trd-root" :style="themePageStyle">
  <nav class="trd-topbar"><div class="container d-flex align-items-center justify-content-between py-2">
    <div class="d-flex align-items-center" style="gap:12px;">
      <back-button class="me-2" />
      <a href="javascript:void(0)" @click="$router.push('/')"><img src="/assets/images/flockr_logo.png" alt="Flockr" style="height:34px;" /></a>
      <span class="fw-semibold" style="color:var(--fm-h,#F5F0E8);font-size:15px;">🚛 Transporter Dashboard</span>
    </div>
    <button class="btn btn-sm btn-outline-warning" @click="$router.push('/transport')"><i class="mdi mdi-magnify me-1"></i>Find Jobs</button>
  </div></nav>

  <div class="container trd-container">
    <div v-if="loading" class="text-center py-5"><div class="spinner-border text-warning"></div></div>

    <div v-else-if="!profile" class="text-center py-5">
      <i class="mdi mdi-truck-outline" style="font-size:64px;color:var(--fm-s,#3A3530);"></i>
      <h5 class="mt-3" style="color:var(--fm-h,#F5F0E8);">No Transporter Profile</h5>
      <p style="color:var(--fm-s,#6B6356);">Register your transport business to start receiving jobs from farmers and buyers.</p>
      <button class="btn btn-warning mt-2" @click="openRegister"><i class="mdi mdi-plus me-1"></i>Register as Transporter</button>
    </div>

    <div v-else>
      <!-- Profile header -->
      <div class="trd-card mb-3 d-flex align-items-center justify-content-between" style="gap:12px;">
        <div class="d-flex align-items-center" style="gap:12px;min-width:0;">
          <div class="trd-avatar">🚛</div>
          <div style="min-width:0;">
            <div style="color:var(--fm-h,#F5F0E8);font-weight:700;font-size:14px;">{{ profile.company_name || profile.display_name }}</div>
            <div style="color:var(--fm-s,#6B6356);font-size:11px;">
              <span v-if="profile.ntsa_compliance_number">NTSA: {{ profile.ntsa_compliance_number }}</span>
              <span v-if="profile.insurance_provider"> · Insured by {{ profile.insurance_provider }}</span>
            </div>
            <div style="margin-top:3px;">
              <span class="trd-status" :class="profile.status==='active' ? 'st-completed' : 'st-cancelled'">{{ profile.status==='active' ? 'Active' : 'Inactive' }}</span>
              <span v-if="String(profile.ntsa_verified)==='1'" class="trd-status st-confirmed ms-2"><i class="mdi mdi-check-decagram me-1"></i>NTSA Verified</span>
            </div>
          </div>
        </div>
        <button class="btn btn-sm btn-outline-warning" @click="openEdit"><i class="mdi mdi-pencil me-1"></i>Edit</button>
      </div>

      <!-- Stats -->
      <div class="row g-3 mb-4">
        <div class="col-6 col-md-3"><div class="trd-stat"><div class="trd-stat-icon" style="color:#50C878;background:rgba(80,200,120,.1);"><i class="mdi mdi-check-circle"></i></div><div class="trd-stat-val">{{ stats.totalTrips }}</div><div class="trd-stat-lbl">Completed</div></div></div>
        <div class="col-6 col-md-3"><div class="trd-stat"><div class="trd-stat-icon" style="color:#FF9800;background:rgba(255,152,0,.1);"><i class="mdi mdi-clock-alert"></i></div><div class="trd-stat-val">{{ stats.pendingTrips }}</div><div class="trd-stat-lbl">Pending</div></div></div>
        <div class="col-6 col-md-3"><div class="trd-stat"><div class="trd-stat-icon" style="color:#BFA164;background:rgba(191,161,100,.1);"><i class="mdi mdi-cash"></i></div><div class="trd-stat-val">KES {{ fNum(stats.monthEarnings) }}</div><div class="trd-stat-lbl">This Month</div></div></div>
        <div class="col-6 col-md-3"><div class="trd-stat"><div class="trd-stat-icon" style="color:#FFD700;background:rgba(255,215,0,.1);"><i class="mdi mdi-star"></i></div><div class="trd-stat-val">{{ Number(stats.avgRating||0).toFixed(1) }}</div><div class="trd-stat-lbl">Rating ({{ stats.totalReviews }})</div></div></div>
      </div>

      <!-- Tabs -->
      <div class="d-flex gap-2 mb-3 flex-wrap">
        <button v-for="tab in tabs" :key="tab.v" class="trd-tab" :class="{active:activeTab===tab.v}" @click="onTabChange(tab.v)">
          {{ tab.l }}
          <span v-if="tab.v==='upcoming'" class="trd-tab-badge">{{ upcoming.length }}</span>
          <span v-if="tab.v==='open'" class="trd-tab-badge" :style="{background: openJobs.length ? 'rgba(255,152,0,.2)' : '', color: openJobs.length ? '#FF9800' : ''}">{{ openJobs.length }}</span>
          <span v-if="tab.v==='fleet'" class="trd-tab-badge">{{ vehicles.length }}</span>
        </button>
      </div>

      <!-- Upcoming -->
      <div v-if="activeTab==='upcoming'">
        <div v-if="!upcoming.length" class="trd-card text-center py-4">
          <i class="mdi mdi-calendar-blank" style="font-size:36px;color:var(--fm-s,#3A3530);display:block;margin-bottom:8px;"></i>
          <div style="color:var(--fm-s,#6B6356);font-size:13px;">No upcoming trips</div>
        </div>
        <div v-for="b in upcoming" :key="b.id" class="trd-card mb-2" @click="$router.push('/transport/trip/'+b.id)" style="cursor:pointer;">
          <div class="d-flex align-items-start gap-3">
            <div class="trd-avatar sm">{{ (b.requester_name||'F').charAt(0) }}</div>
            <div class="flex-fill">
              <div style="color:var(--fm-h,#F5F0E8);font-weight:600;font-size:13px;">{{ b.requester_name }}</div>
              <div style="color:var(--fm-m,#A09888);font-size:12px;"><i class="mdi mdi-map-marker-outline me-1"></i>{{ b.pickup_address }} → {{ b.delivery_address }}</div>
              <div style="color:var(--fm-s,#6B6356);font-size:11px;margin-top:2px;">
                <span><i class="mdi mdi-calendar me-1"></i>{{ b.scheduled_pickup_date }}</span>
                <span v-if="b.animal_count" class="ms-2"><i class="mdi mdi-paw me-1"></i>{{ b.animal_count }} animal{{ b.animal_count==1?'':'s' }}</span>
                <span class="ms-2 trd-ref">{{ b.booking_ref }}</span>
              </div>
            </div>
            <div class="text-end">
              <span class="trd-status" :class="'st-'+b.status">{{ b.status.replace(/_/g,' ') }}</span>
              <div v-if="b.final_price||b.quoted_price" style="color:#BFA164;font-weight:600;font-size:12px;margin-top:4px;">KES {{ fNum(b.final_price||b.quoted_price) }}</div>
            </div>
          </div>
          <div v-if="b.status==='requested'" class="d-flex gap-2 mt-3 pt-2" style="border-top:1px solid var(--fm-br,#1E1E1E);">
            <button class="btn btn-sm btn-outline-success flex-fill" @click.stop="updateTripStatus(b.id,'confirmed')"><i class="mdi mdi-check me-1"></i>Accept</button>
            <button class="btn btn-sm btn-outline-danger flex-fill" @click.stop="updateTripStatus(b.id,'cancelled')"><i class="mdi mdi-close me-1"></i>Decline</button>
          </div>
        </div>
      </div>

      <!-- Open Jobs (broadcasts) -->
      <div v-if="activeTab==='open'">
        <div class="d-flex justify-content-between align-items-center mb-3">
          <div>
            <h6 style="color:#BFA164;font-size:12px;font-weight:700;text-transform:uppercase;margin:0;">Broadcast Jobs</h6>
            <div style="color:var(--fm-s,#6B6356);font-size:11px;margin-top:2px;">
              Unassigned transport requests near you
              <span v-if="transporterRadiusKm">— sorted by distance from your base</span>
            </div>
          </div>
          <button class="btn btn-sm btn-outline-warning" @click="loadOpenJobs" :disabled="loadingOpenJobs">
            <span v-if="loadingOpenJobs" class="spinner-border spinner-border-sm me-1"></span>
            <i v-else class="mdi mdi-refresh me-1"></i>Refresh
          </button>
        </div>
        <div v-if="loadingOpenJobs" class="trd-card text-center py-4"><div class="spinner-border text-warning"></div></div>
        <div v-else-if="!openJobs.length" class="trd-card text-center py-4">
          <i class="mdi mdi-truck-outline" style="font-size:36px;color:var(--fm-s,#3A3530);display:block;margin-bottom:8px;"></i>
          <div style="color:var(--fm-s,#6B6356);font-size:13px;">No open transport requests right now</div>
          <div style="color:var(--fm-s,#6B6356);font-size:11px;margin-top:4px;">You'll get a notification when a new job is broadcast in your area.</div>
        </div>
        <div v-for="b in openJobs" :key="b.id" class="trd-card mb-2">
          <div class="d-flex align-items-start gap-3">
            <div class="trd-avatar sm" style="background:rgba(255,152,0,.1);color:#FF9800;"><i class="mdi mdi-broadcast" style="font-size:18px;"></i></div>
            <div class="flex-fill">
              <div style="color:var(--fm-h,#F5F0E8);font-weight:600;font-size:13px;">{{ b.requester_name || 'Farmer' }}</div>
              <div style="color:var(--fm-m,#A09888);font-size:12px;margin-top:2px;">
                <i class="mdi mdi-map-marker-outline me-1" style="color:#4FC3F7;"></i>{{ b.pickup_address }}
                <i class="mdi mdi-arrow-right mx-1" style="color:var(--fm-s,#6B6356);"></i>
                <i class="mdi mdi-map-marker-check me-1" style="color:#50C878;"></i>{{ b.delivery_address }}
              </div>
              <div style="color:var(--fm-s,#6B6356);font-size:11px;margin-top:4px;">
                <span><i class="mdi mdi-calendar me-1"></i>{{ b.scheduled_pickup_date }}<span v-if="b.scheduled_pickup_time"> · {{ b.scheduled_pickup_time }}</span></span>
                <span v-if="b.animal_count" class="ms-2"><i class="mdi mdi-paw me-1"></i>{{ b.animal_count }} animal{{ b.animal_count==1?'':'s' }}</span>
                <span v-if="b.animal_type_description" class="ms-2">· {{ b.animal_type_description }}</span>
                <span class="ms-2 trd-ref">{{ b.booking_ref }}</span>
              </div>
              <div v-if="b.special_instructions" style="color:var(--fm-m,#A09888);font-size:11px;margin-top:4px;font-style:italic;">{{ b.special_instructions }}</div>
            </div>
            <div class="text-end" style="flex-shrink:0;">
              <div v-if="b.distance_km" style="color:#BFA164;font-size:11px;font-weight:600;"><i class="mdi mdi-map-marker-distance me-1"></i>{{ Number(b.distance_km).toFixed(1) }} km away</div>
              <div v-if="b.quoted_price" style="color:#BFA164;font-weight:600;font-size:13px;margin-top:4px;">KES {{ fNum(b.quoted_price) }}</div>
              <div v-if="!b.quoted_price && b.requester_phone" style="color:var(--fm-s,#6B6356);font-size:10px;margin-top:4px;">No quote yet</div>
            </div>
          </div>
          <div class="d-flex gap-2 mt-3 pt-2" style="border-top:1px solid var(--fm-br,#1E1E1E);">
            <button class="btn btn-sm btn-outline-secondary" @click="$router.push('/transport/trip/'+b.id)"><i class="mdi mdi-eye me-1"></i>Details</button>
            <button class="btn btn-sm btn-warning flex-fill" @click="claimJob(b)" :disabled="claimingId===b.id">
              <span v-if="claimingId===b.id" class="spinner-border spinner-border-sm me-1"></span>
              <i v-else class="mdi mdi-hand-back-right me-1"></i>
              {{ claimingId===b.id ? 'Claiming…' : 'Claim This Job' }}
            </button>
          </div>
        </div>
      </div>

      <!-- Completed -->
      <div v-if="activeTab==='recent'">
        <div v-if="!recent.length" class="trd-card text-center py-4"><div style="color:var(--fm-s,#6B6356);font-size:13px;">No completed trips yet</div></div>
        <div v-for="b in recent" :key="b.id" class="trd-card mb-2" @click="$router.push('/transport/trip/'+b.id)" style="cursor:pointer;">
          <div class="d-flex align-items-center gap-3">
            <div class="trd-avatar sm" style="background:rgba(80,200,120,.1);color:#50C878;">✓</div>
            <div class="flex-fill">
              <div style="color:var(--fm-h,#F5F0E8);font-weight:600;font-size:13px;">{{ b.requester_name }}</div>
              <div style="color:var(--fm-m,#A09888);font-size:12px;">{{ b.pickup_address }} → {{ b.delivery_address }}</div>
              <div style="color:var(--fm-s,#6B6356);font-size:10px;">{{ formatDate(b.actual_delivery_at) }} · {{ b.booking_ref }}</div>
            </div>
            <div style="color:#BFA164;font-weight:600;font-size:13px;">KES {{ fNum(b.final_price||b.quoted_price) }}</div>
          </div>
        </div>
      </div>

      <!-- Fleet -->
      <div v-if="activeTab==='fleet'">
        <div class="d-flex justify-content-between align-items-center mb-3">
          <h6 style="color:#BFA164;font-size:12px;font-weight:700;text-transform:uppercase;margin:0;">Your Fleet</h6>
          <button class="btn btn-sm btn-warning" @click="showAddVehicle=true"><i class="mdi mdi-plus me-1"></i>Add Vehicle</button>
        </div>
        <div v-if="!vehicles.length" class="trd-card text-center py-4"><div style="color:var(--fm-s,#6B6356);font-size:13px;">No vehicles yet. Add your first vehicle to start receiving jobs.</div></div>
        <div v-for="v in vehicles" :key="v.id" class="trd-card mb-2">
          <div class="d-flex align-items-center gap-3">
            <div class="trd-avatar sm"><i class="mdi mdi-truck" style="font-size:18px;"></i></div>
            <div class="flex-fill">
              <div style="color:var(--fm-h,#F5F0E8);font-weight:600;font-size:13px;text-transform:capitalize;">{{ v.vehicle_type.replace(/_/g,' ') }}
                <span v-if="v.make||v.model" style="color:var(--fm-m,#A09888);font-weight:400;">— {{ v.make }} {{ v.model }}</span>
              </div>
              <div style="color:var(--fm-s,#6B6356);font-size:11px;">
                <span class="trd-ref">{{ v.registration_number }}</span>
                <span v-if="v.capacity_description" class="ms-2">· {{ v.capacity_description }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Toast -->
  <transition name="trd-toast-fade">
    <div v-if="toast.show" class="trd-toast" :class="'toast-'+toast.type">
      <i class="mdi" :class="toast.type==='success' ? 'mdi-check-circle' : 'mdi-alert-circle'"></i>
      <span>{{ toast.msg }}</span>
    </div>
  </transition>

  <!-- Register / Edit Modal -->
  <div v-if="showRegister" class="trd-overlay" @click.self="closeRegister">
    <div class="trd-modal">
      <div class="trd-modal-hd">
        <div>
          <div style="color:#BFA164;font-size:11px;font-weight:700;text-transform:uppercase;letter-spacing:.5px;">{{ editMode ? 'Edit Profile' : 'Transporter Onboarding' }}</div>
          <h5 style="color:var(--fm-h,#F5F0E8);margin:2px 0 0;font-size:17px;font-weight:700;">{{ editMode ? 'Update Transporter Profile' : 'Register as Transporter' }}</h5>
        </div>
        <button class="trd-x" @click="closeRegister">&times;</button>
      </div>

      <div class="trd-modal-bd">
        <div v-if="regError" class="trd-alert">{{ regError }}</div>

        <h6 class="trd-sect">Business Details</h6>
        <div class="row g-2">
          <div class="col-md-8"><label class="trd-lbl">Company / Business Name</label><input v-model="reg.companyName" class="trd-inp" placeholder="e.g. Safari Livestock Transport Ltd" /></div>
          <div class="col-md-4"><label class="trd-lbl">NTSA Compliance No.</label><input v-model="reg.ntsaNumber" class="trd-inp" placeholder="NTSA/12345" /></div>
          <div class="col-12"><label class="trd-lbl">About the Business</label><textarea v-model="reg.bio" rows="2" class="trd-inp" placeholder="Years of experience, specialties, service area..." /></div>
        </div>

        <h6 class="trd-sect mt-3">Licence &amp; Insurance</h6>
        <div class="row g-2">
          <div class="col-md-6"><label class="trd-lbl">Transport Licence No.</label><input v-model="reg.transportLicense" class="trd-inp" placeholder="TL/12345" /></div>
          <div class="col-md-6"><label class="trd-lbl">Insurance Provider</label><input v-model="reg.insuranceProvider" class="trd-inp" placeholder="e.g. Jubilee Insurance" /></div>
          <div class="col-md-6"><label class="trd-lbl">Insurance Policy No.</label><input v-model="reg.insurancePolicyNumber" class="trd-inp" placeholder="POL/12345" /></div>
          <div class="col-md-6"><label class="trd-lbl">Insurance Expiry</label><input v-model="reg.insuranceExpiry" type="date" class="trd-inp" /></div>
        </div>

        <h6 class="trd-sect mt-3">Animal Types Served</h6>
        <div class="d-flex flex-wrap gap-2">
          <button type="button" v-for="s in animalOptions" :key="s.v"
                  class="trd-chip" :class="{active: reg.animalTypesServed.includes(s.v)}"
                  @click="toggleAnimal(s.v)">{{ s.l }}</button>
        </div>

        <h6 class="trd-sect mt-3">Capacity</h6>
        <div class="row g-2">
          <div class="col-md-4"><label class="trd-lbl">Max Cattle (large)</label><input v-model.number="reg.maxCapacityLarge" type="number" min="0" class="trd-inp" placeholder="e.g. 20" /></div>
          <div class="col-md-4"><label class="trd-lbl">Max Goats / Sheep</label><input v-model.number="reg.maxCapacitySmall" type="number" min="0" class="trd-inp" placeholder="e.g. 60" /></div>
          <div class="col-md-4"><label class="trd-lbl">Max Poultry</label><input v-model.number="reg.maxCapacityPoultry" type="number" min="0" class="trd-inp" placeholder="e.g. 500" /></div>
        </div>

        <h6 class="trd-sect mt-3">Base Location</h6>
        <div class="row g-2">
          <div class="col-12" style="position:relative;">
            <label class="trd-lbl"><i class="mdi mdi-crosshairs-gps me-1" style="color:#BFA164;"></i>Base Address</label>
            <div style="display:flex;gap:8px;">
              <div style="flex:1;position:relative;">
                <input v-model="reg.baseAddress" class="trd-inp" placeholder="Search town, market, area..." @input="onLocSearch" @focus="showLocResults=true" autocomplete="off" style="padding-right:36px;" />
                <i v-if="geoLoading" class="mdi mdi-loading mdi-spin" style="position:absolute;right:10px;top:50%;transform:translateY(-50%);color:var(--fm-s,#6B6356);"></i>
                <i v-else-if="reg.baseLatitude" class="mdi mdi-check-circle" style="position:absolute;right:10px;top:50%;transform:translateY(-50%);color:#50C878;"></i>
              </div>
              <button type="button" class="trd-gps-btn" @click="useMyLocation" :disabled="geoLoading"><i v-if="geoLoading" class="mdi mdi-loading mdi-spin"></i><i v-else class="mdi mdi-crosshairs-gps"></i></button>
            </div>
            <div v-if="showLocResults && locResults.length > 0" class="trd-loc-dropdown">
              <div v-for="(loc, li) in locResults" :key="li" class="trd-loc-item" @click="pickLocation(loc)">
                <i class="mdi mdi-map-marker" style="color:#BFA164;flex-shrink:0;margin-top:2px;"></i>
                <div><div style="font-size:13px;color:var(--fm-h,#F5F0E8);">{{ loc.display_name }}</div><div style="font-size:11px;color:var(--fm-s,#6B6356);">{{ loc.area }}</div></div>
              </div>
            </div>
          </div>
          <div class="col-md-6"><label class="trd-lbl">Service Radius (km)</label><input v-model.number="reg.serviceRadiusKm" type="number" min="1" class="trd-inp" placeholder="100" /></div>
          <div v-if="reg.baseLatitude && reg.baseLongitude" class="col-md-6" style="display:flex;align-items:flex-end;font-size:11px;color:#50C878;"><i class="mdi mdi-check-circle me-1"></i>{{ Number(reg.baseLatitude).toFixed(4) }}, {{ Number(reg.baseLongitude).toFixed(4) }}</div>
        </div>
      </div>

      <div class="trd-modal-ft">
        <button v-if="editMode && profile && profile.status==='active'" class="btn btn-sm btn-outline-danger me-auto" @click="deactivateProfile" :disabled="registering"><i class="mdi mdi-pause-circle-outline me-1"></i>Deactivate</button>
        <button v-else-if="editMode && profile && profile.status!=='active'" class="btn btn-sm btn-outline-success me-auto" @click="reactivateProfile" :disabled="registering"><i class="mdi mdi-play-circle-outline me-1"></i>Reactivate</button>
        <button class="btn btn-sm btn-outline-secondary" @click="closeRegister" :disabled="registering">Cancel</button>
        <button class="btn btn-sm btn-warning" @click="submitRegistration" :disabled="registering"><span v-if="registering" class="spinner-border spinner-border-sm me-1"></span><i v-else class="mdi mdi-check-circle me-1"></i>{{ registering ? 'Saving…' : (editMode ? 'Save Changes' : 'Submit Registration') }}</button>
      </div>
    </div>
  </div>

  <!-- Add Vehicle Modal -->
  <div v-if="showAddVehicle" class="trd-overlay" @click.self="showAddVehicle=false">
    <div class="trd-modal" style="max-width:460px;">
      <div class="trd-modal-hd">
        <h5 style="color:var(--fm-h,#F5F0E8);margin:0;font-size:17px;font-weight:700;">Add Vehicle</h5>
        <button class="trd-x" @click="showAddVehicle=false">&times;</button>
      </div>
      <div class="trd-modal-bd">
        <div class="row g-2">
          <div class="col-md-6"><label class="trd-lbl">Vehicle Type *</label>
            <select v-model="newVehicle.vehicleType" class="trd-inp">
              <option value="">—</option>
              <option value="pickup">Pickup truck</option>
              <option value="flatbed">Flatbed truck</option>
              <option value="box_truck">Box truck</option>
              <option value="livestock_lorry">Livestock lorry</option>
              <option value="trailer">Trailer</option>
              <option value="van">Van</option>
              <option value="motorcycle">Motorcycle (poultry)</option>
              <option value="other">Other</option>
            </select>
          </div>
          <div class="col-md-6"><label class="trd-lbl">Registration No. *</label><input v-model="newVehicle.registrationNumber" class="trd-inp" placeholder="KCA 123A" /></div>
          <div class="col-md-6"><label class="trd-lbl">Make</label><input v-model="newVehicle.make" class="trd-inp" placeholder="e.g. Isuzu" /></div>
          <div class="col-md-6"><label class="trd-lbl">Model</label><input v-model="newVehicle.model" class="trd-inp" placeholder="e.g. FRR" /></div>
          <div class="col-12"><label class="trd-lbl">Capacity / Notes</label><input v-model="newVehicle.capacityDescription" class="trd-inp" placeholder="e.g. Fits 15 cattle or 50 goats; ventilated and partitioned" /></div>
        </div>
      </div>
      <div class="trd-modal-ft">
        <button class="btn btn-sm btn-outline-secondary" @click="showAddVehicle=false" :disabled="addingVehicle">Cancel</button>
        <button class="btn btn-sm btn-warning" @click="addVehicle" :disabled="addingVehicle||!newVehicle.vehicleType||!newVehicle.registrationNumber"><span v-if="addingVehicle" class="spinner-border spinner-border-sm me-1"></span>Add Vehicle</button>
      </div>
    </div>
  </div>
</div>
</template>

<style>
:root{--fm-h:#F5F0E8;--fm-s:#6B6356;--fm-m:#A09888;--fm-bg1:#141414;--fm-bg2:#0F0F0F;--fm-bg3:#1E1E1E;--fm-br:#1E1E1E}
html[data-theme="light"]{--fm-h:#1A1A1A;--fm-s:#777;--fm-m:#555;--fm-bg1:#FFFFFF;--fm-bg2:#F7F5F2;--fm-bg3:#F0EBE4;--fm-br:#E8E2DA}
html[data-theme="light"] body{background:#F7F5F2!important;color:#1A1A1A!important}
html[data-theme="light"] .trd-root{background:#F7F5F2!important}
html[data-theme="light"] .trd-topbar{background:rgba(255,255,255,.95)!important;border-bottom-color:#E8E2DA!important}
html[data-theme="light"] .trd-card,.trd-stat{background:#FFFFFF!important;border-color:#E8E2DA!important}
html[data-theme="light"] .trd-tab{background:#FFFFFF!important;border-color:#E8E2DA!important;color:#555!important}
html[data-theme="light"] .trd-tab.active{background:rgba(191,161,100,.1)!important;border-color:#BFA164!important;color:#BFA164!important}
</style>

<style scoped>
.trd-root{background:var(--fm-bg2,#0A0A0A);min-height:100vh}
.trd-topbar{position:sticky;top:0;z-index:100;padding:12px 0;background:var(--fm-bg1,#141414);backdrop-filter:blur(10px);border-bottom:1px solid var(--fm-br,#1E1E1E)}
.trd-container{padding-top:80px;padding-bottom:60px;max-width:900px}
.trd-stat{background:var(--fm-bg1,#141414);border:1px solid var(--fm-br,#1E1E1E);border-radius:10px;padding:16px;display:flex;align-items:center;gap:12px}
.trd-stat-icon{width:40px;height:40px;border-radius:10px;display:flex;align-items:center;justify-content:center;font-size:18px;flex-shrink:0}
.trd-stat-val{font-size:18px;font-weight:700;color:var(--fm-h,#F5F0E8)}
.trd-stat-lbl{font-size:10px;color:var(--fm-s,#6B6356)}
.trd-tab{padding:8px 16px;border-radius:20px;border:1px solid var(--fm-br,#1E1E1E);background:var(--fm-bg1,#141414);color:var(--fm-m,#A09888);font-size:12px;cursor:pointer;transition:all .2s}
.trd-tab.active{background:rgba(191,161,100,.1);border-color:#BFA164;color:#BFA164;font-weight:600}
.trd-tab-badge{background:rgba(191,161,100,.15);color:#BFA164;padding:1px 6px;border-radius:8px;font-size:10px;margin-left:4px}
.trd-card{background:var(--fm-bg1,#141414);border:1px solid var(--fm-br,#1E1E1E);border-radius:10px;padding:16px}
.trd-avatar{width:48px;height:48px;border-radius:50%;background:var(--fm-bg3,#1E1E1E);display:flex;align-items:center;justify-content:center;font-size:18px;font-weight:700;color:#BFA164;flex-shrink:0}
.trd-avatar.sm{width:40px;height:40px;font-size:14px}
.trd-status{font-size:10px;font-weight:600;padding:2px 8px;border-radius:8px;text-transform:capitalize}
.st-requested{background:rgba(255,152,0,.1);color:#FF9800}
.st-quoted{background:rgba(255,152,0,.15);color:#FF9800}
.st-confirmed{background:rgba(79,195,247,.1);color:#4FC3F7}
.st-en_route_to_pickup,.st-at_pickup,.st-loading,.st-in_transit,.st-rest_stop,.st-at_delivery,.st-unloading{background:rgba(191,161,100,.15);color:#BFA164}
.st-completed{background:rgba(80,200,120,.1);color:#50C878}
.st-cancelled{background:rgba(255,107,107,.1);color:#FF6B6B}
.trd-ref{background:rgba(191,161,100,.08);color:#BFA164;padding:1px 6px;border-radius:4px;font-family:monospace;font-size:10px}

/* Modal */
.trd-overlay{position:fixed;inset:0;background:rgba(0,0,0,.75);z-index:500;display:flex;align-items:center;justify-content:center;padding:16px;overflow-y:auto}
.trd-modal{background:var(--fm-bg1,#141414);border:1px solid var(--fm-br,#1E1E1E);border-radius:12px;width:100%;max-width:620px;max-height:92vh;display:flex;flex-direction:column;box-shadow:0 20px 60px rgba(0,0,0,.5)}
.trd-modal-hd{display:flex;align-items:flex-start;justify-content:space-between;padding:18px 20px;border-bottom:1px solid var(--fm-br,#1E1E1E)}
.trd-modal-bd{padding:18px 20px;overflow-y:auto;flex:1}
.trd-modal-ft{display:flex;justify-content:flex-end;gap:8px;padding:14px 20px;border-top:1px solid var(--fm-br,#1E1E1E)}
.trd-x{background:transparent;border:none;color:var(--fm-m,#A09888);font-size:26px;line-height:1;cursor:pointer;padding:0 4px}
.trd-x:hover{color:#FF6B6B}
.trd-sect{color:#BFA164;font-size:11px;font-weight:700;text-transform:uppercase;letter-spacing:.5px;margin:0 0 8px}
.trd-lbl{display:block;color:var(--fm-m,#A09888);font-size:11px;font-weight:600;margin-bottom:4px}
.trd-inp{width:100%;padding:8px 10px;background:var(--fm-bg2,#0F0F0F);border:1px solid var(--fm-br,#1E1E1E);border-radius:6px;color:var(--fm-h,#F5F0E8);font-size:13px;outline:none;transition:border-color .15s}
.trd-inp:focus{border-color:#BFA164}
.trd-chip{padding:6px 12px;border-radius:16px;border:1px solid var(--fm-br,#1E1E1E);background:var(--fm-bg2,#0F0F0F);color:var(--fm-m,#A09888);font-size:12px;cursor:pointer;transition:all .15s}
.trd-chip.active{background:rgba(191,161,100,.12);border-color:#BFA164;color:#BFA164;font-weight:600}
.trd-alert{background:rgba(255,107,107,.1);border:1px solid rgba(255,107,107,.3);color:#FF6B6B;padding:8px 12px;border-radius:6px;font-size:12px;margin-bottom:12px}
.trd-gps-btn{width:40px;height:40px;display:flex;align-items:center;justify-content:center;background:var(--fm-bg2,#0F0F0F);border:1px solid var(--fm-br,#1E1E1E);border-radius:6px;color:#BFA164;cursor:pointer;flex-shrink:0}
.trd-loc-dropdown{position:absolute;left:0;right:48px;top:100%;background:var(--fm-bg1,#141414);border:1px solid var(--fm-br,#1E1E1E);border-radius:6px;max-height:240px;overflow-y:auto;z-index:10;box-shadow:0 8px 20px rgba(0,0,0,.4);margin-top:4px}
.trd-loc-item{display:flex;align-items:flex-start;gap:8px;padding:10px 12px;cursor:pointer;border-bottom:1px solid var(--fm-br,#1A1A1A)}
.trd-loc-item:hover{background:rgba(191,161,100,.08)}
.trd-loc-item:last-child{border-bottom:none}

/* Toast */
.trd-toast{position:fixed;top:24px;left:50%;transform:translateX(-50%);z-index:900;display:flex;align-items:center;gap:10px;padding:12px 18px;border-radius:10px;font-size:13px;font-weight:600;box-shadow:0 10px 30px rgba(0,0,0,.4);max-width:92vw}
.trd-toast .mdi{font-size:20px}
.trd-toast.toast-success{background:#1E3A2B;border:1px solid #50C878;color:#9FE8B5}
.trd-toast.toast-error{background:#3A1E1E;border:1px solid #FF6B6B;color:#FFB5B5}
.trd-toast-fade-enter-active,.trd-toast-fade-leave-active{transition:all .25s ease}
.trd-toast-fade-enter-from,.trd-toast-fade-leave-to{opacity:0;transform:translate(-50%,-12px)}

/* ===== MOBILE — feels-like-an-app ===== */
@media (max-width: 768px) {
  .trd-container { padding-top: 70px !important; padding-bottom: calc(80px + env(safe-area-inset-bottom, 0px)) !important; padding-left: 12px !important; padding-right: 12px !important; }
  .trd-card { padding: 12px !important; border-radius: 10px !important; }
  .trd-tab { font-size: 12px; padding: 8px 12px; }
  .trd-toast { font-size: 12px; padding: 8px 14px; }
}
</style>

<script>
/* eslint-disable */
import { executeJson, flocker } from "@/api";
export default {
  name: "TransporterDashboard",
  data(){return{
    darkMode:(document.documentElement.getAttribute('data-theme')||localStorage.getItem('flockr_theme')||'dark')!=='light',
    themeObserver:null,loading:true,
    profile:null,stats:{},upcoming:[],recent:[],vehicles:[],
    activeTab:'upcoming',showRegister:false,editMode:false,registering:false,regError:'',
    locResults:[],showLocResults:false,locSearchTimer:null,geoLoading:false,
    showAddVehicle:false,addingVehicle:false,
    newVehicle:{vehicleType:'',make:'',model:'',registrationNumber:'',capacityDescription:''},
    reg:{companyName:'',bio:'',ntsaNumber:'',transportLicense:'',insuranceProvider:'',insurancePolicyNumber:'',insuranceExpiry:'',animalTypesServed:[],maxCapacityLarge:null,maxCapacitySmall:null,maxCapacityPoultry:null,baseAddress:'',baseLatitude:null,baseLongitude:null,serviceRadiusKm:100},
    animalOptions:[
      {v:'cattle',l:'Cattle'},{v:'goats',l:'Goats'},{v:'sheep',l:'Sheep'},
      {v:'pigs',l:'Pigs'},{v:'poultry',l:'Poultry'},{v:'camels',l:'Camels'},
      {v:'donkeys',l:'Donkeys'},{v:'pets',l:'Pets'}
    ],
    tabs:[{v:'upcoming',l:'Trips'},{v:'open',l:'Open Jobs'},{v:'recent',l:'Completed'},{v:'fleet',l:'Fleet'}],
    openJobs:[],loadingOpenJobs:false,claimingId:null,transporterRadiusKm:null,
    toast:{show:false,msg:'',type:'success'},toastTimer:null
  }},
  computed:{
    themePageStyle(){return this.darkMode?'background:#0A0A0A;min-height:100vh;color:#F5F0E8;':'background:#F7F5F2;min-height:100vh;color:#1A1A1A;'}
  },
  mounted(){
    var t=localStorage.getItem('flockr_theme')||'dark';window.__flockrSetTheme(t);
    this.darkMode=t!=='light';
    this.syncTheme();this.themeObserver=new MutationObserver(this.syncTheme);
    this.themeObserver.observe(document.documentElement,{attributes:true,attributeFilter:['data-theme']});
    this.loadDashboard();
  },
  beforeUnmount(){if(this.themeObserver)this.themeObserver.disconnect();if(this.toastTimer)clearTimeout(this.toastTimer);if(this.locSearchTimer)clearTimeout(this.locSearchTimer);},
  methods:{
    syncTheme(){this.darkMode=document.documentElement.getAttribute('data-theme')!=='light'},
    fNum(n){return Number(n||0).toLocaleString()},
    formatDate(d){if(!d)return'';return new Date(d).toLocaleDateString('en-KE',{day:'numeric',month:'short'})},
    showToast(msg,type){if(this.toastTimer)clearTimeout(this.toastTimer);this.toast={show:true,msg:msg,type:type||'success'};var self=this;this.toastTimer=setTimeout(function(){self.toast.show=false;},3000);},
    async loadDashboard(){
      this.loading=true;
      var userId=sessionStorage.getItem('userId');
      if(!userId){this.$router.push('/login');return}
      try{
        var r=await executeJson({function:'getTransporterDashboard',transporterUserId:userId},flocker);
        if(r.data&&r.data.success&&r.data.data){
          this.profile=r.data.data.profile;
          this.stats=r.data.data.stats||{};
          this.upcoming=r.data.data.upcoming||[];
          this.recent=r.data.data.recent||[];
          this.vehicles=r.data.data.vehicles||[];
        }
      }catch(e){console.error(e)}
      this.loading=false;
      // Pre-load open broadcast jobs so the badge count is live without flipping tabs
      if(this.profile && this.profile.status==='active') this.loadOpenJobs();
    },
    onTabChange(v){
      this.activeTab=v;
      if(v==='open') this.loadOpenJobs();
    },
    async loadOpenJobs(){
      var userId=sessionStorage.getItem('userId');
      if(!userId)return;
      this.loadingOpenJobs=true;
      try{
        var r=await executeJson({function:'getOpenTransportRequests',transporterUserId:userId},flocker);
        if(r.data&&r.data.success&&r.data.data){
          this.openJobs=r.data.data.bookings||[];
          this.transporterRadiusKm=r.data.data.transporterRadiusKm||null;
        }
      }catch(e){console.error(e)}
      this.loadingOpenJobs=false;
    },
    async claimJob(b){
      if(!confirm('Claim this job? You will become the assigned transporter and the farmer will be notified.'))return;
      var userId=sessionStorage.getItem('userId');
      if(!userId)return;
      this.claimingId=b.id;
      try{
        var r=await executeJson({function:'claimTransportBooking',bookingId:b.id,transporterUserId:userId},flocker);
        if(r.data&&r.data.success){
          this.showToast('Job claimed — moving to your trips','success');
          await this.loadOpenJobs();
          await this.loadDashboard();
          this.activeTab='upcoming';
        }else{
          this.showToast((r.data&&r.data.message)||'Could not claim — someone else may have got it first','error');
          await this.loadOpenJobs();
        }
      }catch(e){this.showToast('Network error','error')}
      this.claimingId=null;
    },
    async updateTripStatus(bookingId,status){
      try{
        var actorUserId=sessionStorage.getItem('userId')||'';
        var r=await executeJson({function:'updateTransportStatus',bookingId:bookingId,status:status,actorUserId:actorUserId},flocker);
        if(r.data&&r.data.success){
          await this.loadDashboard();
          var labels={confirmed:'Trip accepted',cancelled:'Trip declined'};
          this.showToast(labels[status]||'Status updated','success');
        }
      }catch(e){this.showToast('Error updating status','error');}
    },
    toggleAnimal(v){var i=this.reg.animalTypesServed.indexOf(v);if(i>=0) this.reg.animalTypesServed.splice(i,1); else this.reg.animalTypesServed.push(v)},
    openRegister(){
      this.editMode=false;
      this.reg={companyName:'',bio:'',ntsaNumber:'',transportLicense:'',insuranceProvider:'',insurancePolicyNumber:'',insuranceExpiry:'',animalTypesServed:[],maxCapacityLarge:null,maxCapacitySmall:null,maxCapacityPoultry:null,baseAddress:'',baseLatitude:null,baseLongitude:null,serviceRadiusKm:100};
      this.regError='';this.locResults=[];this.showLocResults=false;
      this.showRegister=true;
    },
    openEdit(){
      if(!this.profile)return;
      var p=this.profile;
      var at=[];try{at=typeof p.animal_types_served==='string'?JSON.parse(p.animal_types_served||'[]'):(p.animal_types_served||[])}catch(e){at=[]}
      this.editMode=true;
      this.reg={
        companyName:p.company_name||'',bio:p.bio||'',
        ntsaNumber:p.ntsa_compliance_number||'',transportLicense:p.transport_license||'',
        insuranceProvider:p.insurance_provider||'',insurancePolicyNumber:p.insurance_policy_number||'',insuranceExpiry:p.insurance_expiry||'',
        animalTypesServed:Array.isArray(at)?at:[],
        maxCapacityLarge:p.max_capacity_large?Number(p.max_capacity_large):null,
        maxCapacitySmall:p.max_capacity_small?Number(p.max_capacity_small):null,
        maxCapacityPoultry:p.max_capacity_poultry?Number(p.max_capacity_poultry):null,
        baseAddress:'',baseLatitude:p.base_latitude?Number(p.base_latitude):null,baseLongitude:p.base_longitude?Number(p.base_longitude):null,
        serviceRadiusKm:p.service_radius_km?Number(p.service_radius_km):100
      };
      this.regError='';this.locResults=[];this.showLocResults=false;
      this.showRegister=true;
    },
    closeRegister(){if(this.registering)return;this.showRegister=false;this.regError='';this.editMode=false;},
    async submitRegistration(){
      this.regError='';
      var userId=sessionStorage.getItem('userId');
      if(!userId){this.$router.push('/login');return}
      this.registering=true;
      var payload={
        function:this.editMode?'updateTransporterProfile':'registerTransporter',
        userId:userId,
        companyName:this.reg.companyName||'',bio:this.reg.bio||'',
        ntsaNumber:this.reg.ntsaNumber||'',transportLicense:this.reg.transportLicense||'',
        insuranceProvider:this.reg.insuranceProvider||'',insurancePolicyNumber:this.reg.insurancePolicyNumber||'',insuranceExpiry:this.reg.insuranceExpiry||'',
        animalTypesServed:JSON.stringify(this.reg.animalTypesServed||[]),
        serviceRadiusKm:this.reg.serviceRadiusKm||100,
        maxCapacityLarge:this.reg.maxCapacityLarge||'',maxCapacitySmall:this.reg.maxCapacitySmall||'',maxCapacityPoultry:this.reg.maxCapacityPoultry||'',
        baseLatitude:this.reg.baseLatitude||'',baseLongitude:this.reg.baseLongitude||''
      };
      var wasEdit=this.editMode;
      try{
        var r=await executeJson(payload,flocker);
        if(r.data&&r.data.success){
          await this.loadDashboard();
          this.registering=false;this.closeRegister();
          this.showToast(wasEdit?'Profile updated':'Transporter profile created','success');
          return;
        }else{
          this.regError=(r.data&&r.data.message)||(wasEdit?'Update failed':'Registration failed');
        }
      }catch(e){this.regError=(e.response&&e.response.data&&e.response.data.message)||'Network error'}
      this.registering=false;
    },
    async deactivateProfile(){if(!confirm('Deactivate your transporter profile? You will not receive new bookings until you reactivate.'))return;await this.setProfileStatus('inactive')},
    async reactivateProfile(){await this.setProfileStatus('active')},
    async setProfileStatus(status){
      var userId=sessionStorage.getItem('userId');if(!userId)return;
      this.registering=true;
      try{
        var r=await executeJson({function:'updateTransporterProfile',userId:userId,status:status},flocker);
        if(r.data&&r.data.success){await this.loadDashboard();this.registering=false;this.closeRegister();this.showToast(status==='active'?'Profile reactivated':'Profile deactivated','success');return;}
        else this.regError=(r.data&&r.data.message)||'Failed';
      }catch(e){this.regError='Network error'}
      this.registering=false;
    },
    async addVehicle(){
      this.addingVehicle=true;
      var userId=sessionStorage.getItem('userId');
      try{
        var r=await executeJson({function:'addVehicle',transporterUserId:userId,vehicleType:this.newVehicle.vehicleType,make:this.newVehicle.make,model:this.newVehicle.model,registrationNumber:this.newVehicle.registrationNumber,capacityDescription:this.newVehicle.capacityDescription},flocker);
        if(r.data&&r.data.success){
          this.showAddVehicle=false;
          this.newVehicle={vehicleType:'',make:'',model:'',registrationNumber:'',capacityDescription:''};
          await this.loadDashboard();
          this.showToast('Vehicle added','success');
        }
      }catch(e){this.showToast('Error adding vehicle','error')}
      this.addingVehicle=false;
    },
    // Location search (Nominatim)
    onLocSearch(){
      if(this.locSearchTimer)clearTimeout(this.locSearchTimer);
      var self=this;var q=String(this.reg.baseAddress||'').trim();
      if(q.length<3){this.locResults=[];this.showLocResults=false;return;}
      this.locSearchTimer=setTimeout(function(){self.doLocSearch(q);},400);
    },
    async doLocSearch(q){
      try{
        var url='https://nominatim.openstreetmap.org/search?format=json&countrycodes=ke&limit=6&q='+encodeURIComponent(q);
        var res=await fetch(url);var data=await res.json();
        this.locResults=data.map(function(d){var parts=(d.display_name||'').split(',');return{display_name:parts.slice(0,3).join(', ').trim(),area:parts.slice(1,4).join(', ').trim(),lat:d.lat,lon:d.lon}});
        this.showLocResults=true;
      }catch(e){this.locResults=[]}
    },
    pickLocation(loc){
      this.reg.baseLatitude=Number(loc.lat);this.reg.baseLongitude=Number(loc.lon);
      this.reg.baseAddress=loc.display_name;this.showLocResults=false;
    },
    useMyLocation(){
      if(!navigator.geolocation)return;
      this.geoLoading=true;var self=this;
      navigator.geolocation.getCurrentPosition(
        function(pos){
          self.reg.baseLatitude=pos.coords.latitude;self.reg.baseLongitude=pos.coords.longitude;
          self.geoLoading=false;
          // Reverse geocode
          fetch('https://nominatim.openstreetmap.org/reverse?format=json&lat='+pos.coords.latitude+'&lon='+pos.coords.longitude)
            .then(function(r){return r.json()})
            .then(function(d){if(d&&d.display_name){var parts=d.display_name.split(',');self.reg.baseAddress=parts.slice(0,3).join(',').trim()}}).catch(function(){});
        },
        function(){self.geoLoading=false},{enableHighAccuracy:true,timeout:10000}
      );
    }
  }
};
</script>
